// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"64":"PaymentRequestUi","193":"ShippingLabel","535":"PaymentRequestOverview","865":"KycOnboarding","914":"ExternalIntegrationUi"}[chunkId] || chunkId) + ".mp." + {"7":"c0537e07","64":"0fa6cd39","193":"e55e393d","535":"70ff4570","865":"ef007acd","914":"fd9255e0"}[chunkId] + ".css";
};